<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-11-15 13:09:14
 * @LastEditors: hexy
 * @LastEditTime: 2023-11-27 15:39:10
 * @Description: 发票收取
 * @FilePath: \ICPSxin\src\views\platform\ICPS\GHnumber\payment\invoiceManagement.vue
-->
<template>
    <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 0.625rem">
                <span style="margin-right: 0.75rem">合同签订主体</span>
                <el-input v-model="tableParam.contractSigningSubject" style="width: 200px" clearable placeholder="请输入" />
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">协作主体</span>
                <el-input v-model="tableParam.cooperativeUnit" style="width: 200px" clearable placeholder="请输入" />
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">发票类型</span>
                <el-select v-model="tableParam.billType" style="width: 10rem" placeholder="请选择">
                  <el-option v-for="item in billTypeList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">开票时间</span>
                <el-date-picker
                  v-model="startTimDateEndTimDate"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  @change="(tableParam.billDateStart = startTimDateEndTimDate[0] || ''), (tableParam.billDateEnd = startTimDateEndTimDate[1] || '')"
                ></el-date-picker>
                <!-- <el-date-picker v-model="tableParam.billDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"> </el-date-picker> -->
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 0.75rem" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav" style="height: 45px">
            <div>
              <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加发票')"> 添加发票</el-button>
              <el-button size="small" class="bottom_one" style="margin-left: 10px" @click="exportDialog=true"> 导入 </el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 1.25rem">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-link :underline="false" @click="load()">
                <span class="el-icon--left">
                  <i class="iconfont iconicon_button_export1"></i>
                </span>导出
              </el-link> -->
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :height="screenHeight - 450" :cell-style="{ borderRight: 'none' }" border style="width: 100%" :data="tableData" tooltip-effect="dark">
              <!-- <el-table-column align="center" type="selection" width="50" :selectable="checkSelect"></el-table-column> -->
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width">
                  <template slot-scope="scope">
                    <span v-if="item.label == '税率'">
                        <span>{{ scope.row.taxRate*100 }}%</span>
                    </span>
                    <span v-else-if="item.label == '操作'">
                        <el-button size="mini" style="margin: 0.3125rem 0" class="bottom_one" @click="updateFromDate(scope.row, '修改'),getUint(scope.row)">修改</el-button>
                        <el-button size="mini" style="margin: 0.3125rem 0.2rem" class="bottom_one" @click="DelItem(scope.row)">删除</el-button>
                    </span>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加发票 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="860px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="135px">
          <el-form-item prop="billDate">
            <span slot="label">开票日期</span>
            <el-date-picker v-model="fromDate.billDate" type="date" value-format="yyyy-MM-dd"  style="width: 200px" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item prop="contractSigningSubjectId">
            <span slot="label">合同签订主体</span>
            <span v-if="!fromDate.contractSigningSubjectId" style="color:  #1cc073 ;" @click="getSupplyInfo()">请选择</span>
            <span v-else style="color:  #1cc073 ;" @click="getSupplyInfo()">{{ fromDate.contractSigningSubject }}</span>
          </el-form-item>
          <el-form-item prop="supplierName">
            <span slot="label">合同单位</span>
            <el-input v-model="fromDate.supplierName" disabled style="width: 200px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item  prop="projectId">
            <span slot="label">项目</span>
            <el-select v-model="fromDate.projectId" placeholder="请选择" style="width: 200px">
              <el-option v-for="(item, index) in projectList" :key="index" :label="item.itemName" :value="item.id" @click.native="fromDate.projectName = item.itemName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="cooperativeUnit">
            <span slot="label">协作主体</span>
            <el-select v-model="fromDate.cooperativeUnitId" placeholder="请选择" style="width: 200px">
              <el-option v-for="(item, index) in cooperativeUnitList" :key="index" :label="item.name" :value="item.id" 
              @click.native="fromDate.taxRate = item.taxRate,fromDate.contractCode = item.cooperationNumber
              ,fromDate.cooperativeUnit = item.name" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contractCode">
            <span slot="label">协作合同编码</span>
            <el-input v-model="fromDate.contractCode" disabled style="width: 200px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="taxRate">
            <span slot="label">税率</span>
            <el-input v-model="fromDate.taxRate" disabled style="width: 200px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item  prop="billType">
            <span slot="label">发票类型</span>
            <el-select v-model="fromDate.billType" style="width: 200px" placeholder="请选择">
              <el-option v-for="item in billTypeList" :key="item.id" :label="item.itemName" :value="item.id" @click.native="fromDate.billTypeName = item.itemName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="registerDate">
            <span slot="label">登记日期</span>
            <el-date-picker v-model="fromDate.registerDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 200px"></el-date-picker>
          </el-form-item>
          <el-form-item prop="billNumber">
            <span slot="label">发票号</span>
            <el-input v-model="fromDate.billNumber"  style="width: 200px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="billAllMoney">
            <span slot="label">发票总金额（元）</span>
            <el-input v-model="fromDate.billAllMoney"  style="width: 200px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="shareNumber">
            <span slot="label">共享结算单价号</span>
            <el-input v-model="fromDate.shareNumber"  style="width: 200px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item >
            <span slot="label" >备注</span>
            <el-input v-model="fromDate.remark" style="width: 545px;" type="textarea" :rows="5" resize="none" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">发票上传</span>
            <FileComponent fileCode="contractFile" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择供应商 -->
    <el-dialog v-dialogDrag :visible.sync="supplierDialog" title="选择供应商" width="860px" :close-on-click-modal="false" :before-close="resetSupplyFrom">
      <div>
        <div style="padding-bottom:20px">
          <span style="display: inline-block; margin-bottom: 0.625rem">
              <span style="margin-right: 0.75rem">合同签订主体</span>
              <el-input v-model="tableParamSupply.contractSigningSubject" style="width: 100px" clearable placeholder="请输入" />
          </span>
          <!-- <span >
              <span style="margin-left: 0.75rem;margin-right;: 0.75rem">合同编码</span>
              <el-input v-model="tableParamSupply.contractNumber" style="width: 100px" clearable placeholder="请输入" />
          </span> -->
          <span >
              <span style="margin-left: 0.75rem;margin-right;: 0.75rem">供应商名称</span>
              <el-input v-model="tableParamSupply.supplierName" style="width: 100px" clearable placeholder="请输入" />
          </span>
          <el-button icon="el-icon-search" size="mini" class="bottom_all" @click="getSupplyInfo()">查 询</el-button>
        </div>
        <el-table  :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="contractData" tooltip-effect="dark" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="50"></el-table-column>
          <el-table-column label="合同签订主体" align="center" prop="contractSigningSubject"></el-table-column>
          <el-table-column label="供应商名称" align="center" prop="supplierName"></el-table-column>
          <!-- <el-table-column label="合同" align="center" prop="contractNumber"></el-table-column> -->
        </el-table>
      </div>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ totalSupply }}条</div>
          <el-pagination :current-page.sync="tableParamSupply.page" :page-size="tableParamSupply.pageSize" :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="totalSupply" @size-change="sizeChangeSupply" @current-change="getSupplyInfo()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="getSupplyInfo">刷新</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetSupplyFrom()">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px;" @click="submitSupplyFrom()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 导入 -->
    <el-dialog v-dialogDrag :visible.sync="exportDialog" width="680px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">导入发票信息</span>
      <div v-loading="loading" element-loading-text="数据解析中..." element-loading-background="rgba(0, 0, 0, 0.8)" class="dialoginfo" style="text-align: center">
        <el-upload class="upload-demo" :on-success="fileSuccess" :before-upload="filebefore" :show-file-list="false" drag action="/icps/system/sign/intelligent/invoice/importInvoice" name="file" :headers="upheader">
          <i slot="trigger" class="el-icon-upload"></i>
          <div slot="trigger" class="el-upload__text">
            将文件拖到此处，或
            <em>点击选取文件</em>
          </div>
        </el-upload>
        <div style="padding-top: 10px">
          <el-button class="bottom_all" style="margin-left: 0" @click="importSubmit()">下载模板</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="exportDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import FileComponent from "@/components/File/fileComponent";
import { queryPage,deleteInvoice, Download,getContract,saveInvoice,queryListsByPid} from "@/api/internetSales/invoiceManagement.js";
// import { setgetList } from "@/api/basicConfig/CPYquality.js";
import {getDicType } from "@/api/common.js";
import { getToken, getUserId } from "@/utils/auth";
export default {
  mixins: [mixin],
  components: {
    FileComponent
  },
  data() {
    return {
      exportDialog:false,
      loading: false,
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
      },
      files: [],
      title:"",
      totalSupply:0,
      supplierDialog: false,
      tableParamSupply:{
        contractSigningSubject:"",
        supplierName:"",
        contractNumber:"", //合同
        page:1,
        pageSize:10,
        contractStatus:"",
        contractTypeId:"1", //原物料
        enable: 1
      },
      startTimDateEndTimDate: [],
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "编号", width: "100", prop: "code", status: true, },
        { label: "合同签订主体", width: "auto", prop: "contractSigningSubject", status: true, },
        { label: "协作主体", width: "auto", prop: "cooperativeUnit", status: true, },
        { label: "合同单位", width: "auto", prop: "supplierName", status: true, },
        { label: "协作合同编码", width: "auto", prop: "contractCode", status: true,},
        { label: "项目", width: "auto", prop: "projectName", status: true, },
        { label: "发票类型", width: "auto", prop: "billTypeName", status: true, },
        { label: "发票号", width: "auto", prop: "billNumber", status: true },
        { label: "开票日期", width: "auto", prop: "billDate", status: true },
        { label: "税率", width: "auto", prop: "taxRate", status: true },
        { label: "登记日期", width: "auto", prop: "registerDate", status: true },
        { label: "发票总金额（元）", width: "auto", prop: "billAllMoney", status: true },
        { label: "共享结算单价号", width: "auto", prop: "shareNumber", status: true },
        { label: "备注", width: "auto", prop: "remark", status: true },
        { label: "操作", width: "180", prop: "", status: true, fiexd: "right" },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        billDate: [{ required: true, message: "请选择开票日期", trigger: "change" }],
        contractSigningSubjectId: [{ required: true, message: "请选择合同签订主体", trigger: "change" }],
        supplierName: [{ required: true, message: "请输入合同单位", trigger: "blur" }],
        contractCode: [{ required: true, message: "请输入协作合同编码", trigger: "blur" }],
        projectId: [{ required: true, message: "请选择项目", trigger: "change" }],
        cooperativeUnitId: [{ required: true, message: "请选择协作主体", trigger: "change" }],
        taxRate: [{ required: true, message: "请输入税率", trigger: "blur" }],
        billType: [{ required: true, message: "请选择发票类型", trigger: "change" }],
        registerDate: [{ required: true, message: "请选择登记日期", trigger: "change" }],
        billNumber: [{ required: true, message: "请输入发票号", trigger: "blur" }],
        billAllMoney: [{ required: true, message: "请输入发票总金额", trigger: "blur" }],
        shareNumber: [{ required: true, message: "请输入共享结算单价号", trigger: "blur" }],
      },
      fromDate: {
        billAllMoney: 0,
        billDate: "",
        billDateEnd: "",
        billDateStart: "",
        billType: "",
        billTypeName: "",
        code: "",
        company: "",
        companyId: "",
        contractCode: "",
        contractId: "",
        contractSigningSubject: "",
        contractSigningSubjectId: "",
        cooperativeUnit: "",
        cooperativeUnitId: "",
        dateSharding: "",
        id: "",
        monthSharding: "",
        projectId: "",
        projectName: "",
        registerDate: "",
        remark: "",
        shareNumber: "",
        supplierId: "",
        supplierName: "",
        taxRate: 0,
        file:""
      },
      billTypeList: [],
      projectList: [],
      contractData: [],
      cooperativeUnitList: [],
      selectData:[],
    };
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { 
        ...this.tableParam, 
        billDateStart: "", 
        billDateEnd: "", 
        billType: "", 
        cooperativeUnit: '', 
        contractSigningSubject: "",  
    };
    this.gettableData();
    getDicType({ code: "Invoice_type" }).then(res => {
      if (res.code === 1001) {
        this.billTypeList = res.data.items;
      }
    });
    getDicType({ code: "MATtype" }).then(res => {
      if (res.code === 1001) {
        this.projectList = res.data.items;
      }
    });
    
  },
  /*
   *copy(data)深拷贝数据,返回拷贝完的数据
   *gettableData获取列表数据
   *load下载
   *SortNum保持序列号
   * UpdateOrDelete禁用，启用，删除
   * submitFromDate保存更新数据
   */
  methods: {
    importSubmit(){
      window.open("https://lvshe.huashijc.com/file/group1/M00/0F/C9/ChQACmVkR4CAWTcIAAAl-H6thN017.xlsx");
    },
    /*导入数据*/
    filebefore(file) {
      this.loading = true;
      const isJPG = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isJPG) {
        this.$message.error("数据上传必须是 xlsx 格式!");
        this.loading = false;
      }
      return isJPG;
    },
    fileSuccess(res) {
      this.loading = false;
      if (res.code == 1001) {
        this.$message.error(res.codeMsg);
        // this.$message({
        //   dangerouslyUseHTMLString: true,
        //   message: `本次导入数据成功！！！`,
        //   type: "success",
        // });
        this.exportDialog = false
        this.gettableDataex();
      } else {
        this.$message.error(res.codeMsg);
      }
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
     deleteFile(index) {
      this.files.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      console.log(data);
      this.files = [];
      let item = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(item);
    },
    /*重置数据*/
    init() {
      this.tableParam = {
        ...this.tableParam, 
        billDateStart: "", 
        billDateEnd: "", 
        billType: "", 
        cooperativeUnit: '', 
        contractSigningSubject: "",  
      };
      this.startTimDateEndTimDate = [];
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    sizeChangeSupply(value){
      this.tableParamSupply.pageSize = value;
      this.getSupplyInfo();
    },
    getUint(row){
      queryListsByPid({ supplierId: row.supplierId }).then(res => {
        this.cooperativeUnitList = res.data;
      });
    },
    getSupplyInfo(){
      this.supplierDialog = true
      getContract(this.tableParamSupply).then(res => {
       if (res.code === 1001) {
         this.contractData = res.data.data;
         this.totalSupply = res.data.totalRows
        } 
      });
      
    },
    handleSelectionChange(val){
        this.selectData = val
        if(this.selectData.length>1){
            this.$message.warning("只能选择一条" );
        }
    },
    DelItem(row) {
        this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          let list = []
          list.push(row.id) 
          deleteInvoice(list).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功！");
              this.gettableData();
            }
          });
        })
        .catch(() => {});
    },
    submit() {
        console.log(this.fromDate)
        this.$refs.reffromDate.validate((valid) => {
          if (valid) {
            this.fromDate.file = JSON.stringify(this.files);
              saveInvoice(this.fromDate).then(res => {
                if (res.code === 1001) {
                  this.$message.success("添加成功！！")
                 } else{
                  this.$message.warning("添加失败！！")
                  this.$message.warning(res.data)
                 }
                this.cooperativeUnitList=[]
                this.selectData = []
                this.resetFromDate();
                this.gettableData();
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
    },
    resetSupplyFrom(){
        this.supplierDialog = false
    },
    submitSupplyFrom(){
        let _this = this;
        if(_this.selectData.length<1){
            _this.$message.warning("请先选择一条数据" );
        }else if(_this.selectData.length==1){
            this.fromDate.cooperativeUnit = ""
            this.fromDate.cooperativeUnitId = ""
            this.$set(this.fromDate, 'supplierName', this.selectData[0].supplierName)
            this.$set(this.fromDate, 'supplierId', this.selectData[0].supplierId)
            // this.$set(this.fromDate, 'contractCode', this.selectData[0].contractNumber)
            this.$set(this.fromDate, 'contractSigningSubjectId', this.selectData[0].contractSigningSubjectId)
            this.$set(this.fromDate, 'contractSigningSubject', this.selectData[0].contractSigningSubject)
            // this.$set(this.fromDate, 'taxRate', this.selectData[0].taxRate)
            this.$set(this.fromDate, 'contractId', this.selectData[0].id)
            queryListsByPid({ supplierId: this.selectData[0].supplierId }).then(res => {
              this.cooperativeUnitList = res.data;
            });
        }
        _this.resetSupplyFrom();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo-title {
  display: flex;
  justify-content: space-between;
  padding: 0.625rem 0 1.25rem 0;
}
.textline {
  line-height: 2.5rem;
  display: flex;
  > div:first-child {
    width: 6.25rem;
    text-align: right;
  }
  > div:last-child {
    width: 31.25rem;
  }
}
.table_link {
  margin-left: 0.625rem;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.el-input,
.el-select {
  width: 15rem;
}
.tabtop {
  width: 35.6875rem;
}
.success-row {
  background: #fffd87 !important;
}
</style>
<style scoped>
.auditVolume >>> .el-input__inner {
  color: red;
}
</style>
